<template>
    <ul id="slide-out" class="sidenav fixed">
        <li><div class="user-view">
        <div class="background" style="display: flex;">
            <img src="../assets/images/kiwibackground.jpg">
        </div>
        <h6><span class="white-text">Welcome, <b>{{this.$store.getters.user_session.username}}</b>!</span></h6>
        <br />
        <form v-if="multiplant_selection()">
            <span style="display: flex; width: 100%;">
                <label style="margin-right: 1rem;"><font-awesome-icon  class="white-text" size="2x" :icon="['fas', 'map-marker-alt']"/></label>
                <select class="grey lighten-2 no-autoinit" v-model="selected_plant_id">
                    <option v-for="plant in plant_info" :value="plant.id">{{plant.name}}, {{plant.state}}</option>
                </select>
            </span>
        </form>
        <br />
        </div></li>
        <div class="sidenav-menu">
            <!-- <ul v-if="menu_allowed('admin_tools')" class="collapsible admin-tools orange">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'flask']"/> Labs <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b> </div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/executive_month_to_date_sales"><font-awesome-icon :icon="['far', 'chart-line']"/> KDC Reports</router-link></li>
                        <li><router-link class="waves-effect" to="/executive_month_to_date_sales"><font-awesome-icon :icon="['far', 'wrench']"/> KDC Document Builder</router-link></li>
                        <li><router-link class="waves-effect" to="/executive_month_to_date_sales"><font-awesome-icon :icon="['far', 'envelope']"/> KDC Email Configuration</router-link></li>
                        <li><router-link class="waves-effect" to="/executive_month_to_date_sales"><font-awesome-icon :icon="['far', 'globe']"/> KDC Nexus</router-link></li>
                        <li><router-link class="waves-effect" to="/data_workbench"><font-awesome-icon :icon="['far', 'database']" :style="{color: 'white'}"/> Data Workbench</router-link></li>

                        <li><router-link class="waves-effect" to="/kdc_datatable"><font-awesome-icon :icon="['far', 'table']" :style="{color: 'white'}"/> KDC DataTable</router-link></li>
                        <li><router-link class="waves-effect" to="/companies"><font-awesome-icon :icon="['far', 'table']" :style="{color: 'white'}"/> KDataTable Companies</router-link></li>
                    </div>
                </li>
            </ul> -->
            <ul class="collapsible admin-tools">
                <li class="">
                    <div v-if="menu_allowed('admin_tools')" class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'shield-alt']"/> Admin Tools <font-awesome-icon class="sidenav-icon-right fa-rotate-90"  :icon="['far', 'caret-square-down']"/></b> </div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/admin_panel"><font-awesome-icon :icon="['fas', 'cogs']"/> Admin Panel</router-link></li>
                        <li><router-link class="waves-effect" to="/users"><font-awesome-icon :icon="['fas', 'user']"/> Users</router-link></li>
                        <li><router-link class="waves-effect" to="/groups"><font-awesome-icon :icon="['fas', 'users']"/> Groups</router-link></li>
                        <!--<li><router-link class="waves-effect" to="/api_access"><font-awesome-icon :icon="['fas', 'copy']"/> API Access</router-link></li>-->
                        <!-- <li><router-link class="waves-effect" to="/view_roles"><font-awesome-icon :icon="['far', 'eye']"/> View Roles</router-link></li> -->
                        <!-- <li><router-link class="waves-effect" to="/page_access_old"><font-awesome-icon :icon="['fas', 'list']"/> OLD Page Access</router-link></li>
                        <li><router-link class="waves-effect" to="/page_access"><font-awesome-icon :icon="['fas', 'list']"/> Page Access</router-link></li> -->

                        <!-- <li><router-link class="waves-effect" to="/admin_settings"><font-awesome-icon :icon="['fas', 'wrench']"/> Admin Settings</router-link></li> -->
                        <li><router-link class="waves-effect" to="/plant_admin"><font-awesome-icon :icon="['fas', 'industry']"/> Plant Admin</router-link></li>
                        <li><router-link class="waves-effect" to="/vue_services"><font-awesome-icon :icon="['fas', 'power-off']"/>Vue Services</router-link></li>
                        <li><router-link class="waves-effect" to="/esp_services"><font-awesome-icon :icon="['fas', 'power-off']"/> ESP Services</router-link></li>
                        <li><router-link class="waves-effect" to="/shop_settings"><font-awesome-icon icon="store" :style="{color: 'white'}"/> Shop Settings</router-link></li>
                        <li><router-link class="waves-effect" to="/kdc_settings"><font-awesome-icon icon="cogs" :style="{color: 'white'}"/> KDC Settings</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/kdc_customization"><font-awesome-icon icon="paint-roller" :style="{color: 'white'}"/> KDC Customization</router-link></li> -->

                        <!-- <li><router-link class="waves-effect" to="/kdc_configurator"><font-awesome-icon icon="download" :style="{color: 'white'}"/> KDC Configurator</router-link></li> -->


                    </div>
                </li>
            </ul>
            <!-- User Tools -->
            <ul v-if="menu_allowed('user_tools')" class="collapsible user-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'user']"/> User Tools <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b></div>
                    <div class="collapsible-body">
                        <!-- <li><router-link class="waves-effect" to="/manage_account"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'cogs']"/> Manage Account</router-link></li> -->
                        <li><router-link class="waves-effect" to="/dashboard"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'columns']"/> Dashboard</router-link></li>
                        <li><router-link class="waves-effect" to="/companies"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'building']"/> Companies</router-link></li>
                        <li><router-link class="waves-effect" to="/contacts"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'book']"/> Contacts</router-link></li>
                        <li><router-link class="waves-effect" to="/product_designs"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'box-open']"/> Product Designs</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/old_product_designs"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'box-open']"/> OLD Product Designs</router-link></li> -->
                        
                        <li><router-link class="waves-effect" to="/shop"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'store']"/> Order Material</router-link></li>
                        <li><router-link class="waves-effect" to="/shopping_cart"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'shopping-cart']"/> Shopping Cart</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/shopping_cart_history"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'shopping-cart']"/> Order History</router-link></li> -->
                        
                        


                        <!--<li><router-link class="waves-effect" to="/net_waste"><i class="fa fa-trash"></i> Net Waste</router-link></li>
                        <li><router-link class="waves-effect" to="/track_shipping"><i class="pull-right fa fa-truck"></i> Track Shipping</router-link></li> -->


                    </div>
                </li>
            </ul>
            <ul v-if="menu_allowed('executive_tools')" class="collapsible executive-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['far', 'percent']"/> Executive Tools <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b> </div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/executive_month_to_date_sales"><font-awesome-icon :icon="['far', 'chart-line']"/> Month to Date Sales</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/executive_month_to_date_sales_old"><font-awesome-icon :icon="['far', 'chart-line']"/> OLD Month to Date Sales</router-link></li> -->
                        <li><router-link class="waves-effect" to="/overdue_orders"><font-awesome-icon :icon="['far', 'redo']"/> Overdue Orders</router-link></li>
                        <li><router-link class="waves-effect" to="/watchlists"><font-awesome-icon :icon="['far', 'th-list']"/> Watch Lists</router-link></li>



                    </div>
                </li>
            </ul>
            <ul v-if="menu_allowed('sales_tools')" class="collapsible sales-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['far', 'briefcase']"/> Sales Tools <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b> </div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/sales_month_to_date_sales"><font-awesome-icon :icon="['far', 'chart-line']"/> Month to Date Sales</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/sales_month_to_date_sales_old"><font-awesome-icon :icon="['far', 'chart-line']"/> OLD Month to Date Sales</router-link></li> -->

                        <li><router-link class="waves-effect" to="/overdue_orders"><font-awesome-icon :icon="['far', 'redo']"/> Overdue Orders</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/backlog"><font-awesome-icon :icon="['far', 'undo']"/> Backlog</router-link></li> -->
                        <li><router-link class="waves-effect" to="/watchlists"><font-awesome-icon :icon="['far', 'th-list']"/> Watch Lists</router-link></li>
                        

                    </div>
                </li>
            </ul>
            <!-- <ul class="collapsible user-tools">
                <li class="">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['far', 'eye']"/> Vue Tools <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b> </div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/executive_month_to_date"> Month to Date</router-link></li>

                    </div>
                </li>
            </ul> -->
            <ul v-if="menu_allowed('guest_tools')" class="collapsible report-tools user-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'users']"/> Guest Tools <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b></div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect " to="/web_orders"><font-awesome-icon class="red-text text-lighten-1" :icon="['fas', 'desktop']"/> Web Orders</router-link></li>
                        <li><router-link class="waves-effect" to="/shop"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'store']"/> Order Material</router-link></li>
                        <li><router-link class="waves-effect" to="/shopping_cart"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'shopping-cart']"/> Shopping Cart</router-link></li>
                        

                    </div>
                </li>
            </ul>

            <!-- Activity -->
            <ul v-if="menu_allowed('activity_tools')" class="collapsible report-tools user-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'chart-line']"/> Activity <font-awesome-icon class="sidenav-icon-right"  :icon="['far', 'caret-square-down']"/></b></div>
                    <div class="collapsible-body">
                        <!--<li><router-link class="waves-effect " to="/web_orders"><font-awesome-icon class="red-text text-lighten-1" :icon="['fas', 'desktop']"/> Web Orders</router-link></li>-->
                        
                        <li><router-link class="waves-effect" to="/esp_orders"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'th-list']"/> Orders</router-link></li>
                        <li><router-link class="waves-effect" to="/esp_shipments"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'truck']"/> Shipments</router-link></li>
                        <li><router-link class="waves-effect" to="/order_history"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'history']"/> Order History</router-link></li>
                        <!-- <li><router-link class="waves-effect" to="/order_summary"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'list']"/> Order Summary</router-link></li> -->
                        

                    </div>
                </li>
            </ul>
            <!-- RSP Tools-->
            <!-- <ul v-if="menu_allowed('rsp_tools')" class="collapsible rsp-tools user-tools">
                <li class="active">
                    <div class="collapsible-header waves-effect"><b><font-awesome-icon :icon="['fas', 'toilet-paper-alt']" rotation="270"/> Roll Source Tools <font-awesome-icon class="sidenav-icon-right" :icon="['far', 'caret-square-down']" /></b></div>
                    <div class="collapsible-body">
                        <li><router-link class="waves-effect" to="/macop" ><font-awesome-icon class="blue-text text-lighten-1" :icon="['far', 'tachometer-fast']"/> Macop</router-link></li>
                        <li><router-link class="waves-effect" to="/roll_editor" ><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'pencil']"/> Roll Editor</router-link></li>
                        
                        <li><router-link class="waves-effect" to="/paper_admin"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'paste']"/> Paper Admin</router-link></li>
                        <li><router-link class="waves-effect" to="/paper_projections"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'chart-bar']"/> Paper Projections</router-link></li>
                        
                        <li><router-link class="waves-effect" to="/paper_requirements"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'scroll']"/> Paper Requirements</router-link></li>
                        <li><router-link class="waves-effect" to="/vendor_allocation"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'layer-plus']"/> Vendor Allocation</router-link></li>

                        <li><router-link class="waves-effect" to="/roll_source_orders" ><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'th-list']"/> Roll Source Orders</router-link></li>
                        
                        
                        
                        <li><router-link class="waves-effect" to="/order_queue"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'th-list']"/> Order Queue</router-link></li>


                    </div>
                </li>
            </ul> -->
            <!-- Misc Options -->
            <ul v-if="menu_allowed('user_sub')" class="misc-tools">
                <!-- <li><router-link class="waves-effect" to="/help"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'life-ring']"/> Help</router-link></li> -->
                <!-- <li><router-link class="waves-effect" to="/support"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'envelope']"/> Support</router-link></li> -->
                <!--<li>
                    <span>
                        <p><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'paint-brush']"/> Theme </p>
                        <div class="switch">
                            <label>
                                    <font-awesome-icon class="orange-text" :icon="['fas', 'sun']"/>
                                <input type="checkbox" >
                                <span id="theme-lever" class="lever" >
                                </span>
                                    <font-awesome-icon class="black-text" :icon="['fas', 'moon']"/>
                            </label>
                        </div>
                    </span>

                   
                </li>-->

                <!-- <li><router-link class="waves-effect" to="/settings"><font-awesome-icon class="red-text text-lighten-1" :icon="['fas', 'wrench']"/> Settings</router-link></li> -->
                <li><router-link class="waves-effect" to="/logout"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'sign-out-alt']"/> Logout</router-link></li> 
            </ul>
            <br />
            <ul v-if="menu_allowed('guest_sub')" class="misc-tools">
                <!-- <li><router-link class="waves-effect" to="/help"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'life-ring']"/> Help</router-link></li> -->
                <!-- <li><router-link class="waves-effect" to="/support"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'envelope']"/> Support</router-link></li> -->
                <!-- <li><router-link class="waves-effect" to="/settings"><font-awesome-icon class="red-text text-lighten-1" :icon="['fas', 'wrench']"/> Settings</router-link></li> -->
                <li><router-link class="waves-effect" to="/login"><font-awesome-icon class="red-text text-lighten-1" :icon="['far', 'sign-in-alt']"/> Login</router-link></li> 
            </ul>
        </div>
        <div class="signature-logo">

            <a href="#" class="brand-logo"><img src="../assets/images/kiwiplan_logo_original.png" style="width: 50%; margin-left: 25%;"></a>
            <p style="font-size: .75rem; text-align: center;">&copy; Copyright 2020, Kiwiplan, Inc.</p>
            <p style="font-size: .75rem; text-align: center;" class="version-tag"><span style="font-size: 1rem;" class="easteregg">{{easter_egg}}</span> KDC {{version_number}}</p>


        </div>
    </ul>
</template>
<script>

 

import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

import AxiosStorage from 'axios-storage'


import session from 'sessionstorage'



var vthis = this;

export default {
    name: 'sidenav',
    components:{
        
    },
    data(){
        return{
            theme: 0,
            selected_plant_id: this.$store.getters.user_session.selected_plant_id,
            'request_package': {
                'user': JSON.parse(session.getItem('user')),
                
            }
        }
        
    },
    methods:{
        menu_allowed(menu_group){
            var vthis = this;
            var user_group = this.$store.getters.user_session.group;

            if(user_group == 'ADMIN'){
                if(menu_group == 'admin_tools'){
                    return true
                }else if(menu_group == 'executive_tools'){
                    return true
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return true
                }else if(menu_group == 'guest_tools'){
                    return true
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }
            }else if(user_group == 'USER'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return false
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return false
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }
            }else if(user_group == 'CUSTOMER SERVICE'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return false
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return false
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }   
            }else if(user_group == 'SALES'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return false
                }else if(menu_group == 'sales_tools'){
                    return true
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return false
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }
            }else if(user_group == 'EXECUTIVE'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return true
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return false
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }
            }else if(user_group == 'CUSTOMER'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return false
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return true
                }else if(menu_group == 'activity_tools'){
                    return true
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return false
                }else if(menu_group == 'user_sub'){
                    return true
                }else if(menu_group == 'guest_sub'){
                    return false
                }
            }else if(user_group == 'GUEST'){
                if(menu_group == 'admin_tools'){
                    return false
                }else if(menu_group == 'executive_tools'){
                    return false
                }else if(menu_group == 'sales_tools'){
                    return false
                }else if(menu_group == 'user_tools'){
                    return false
                }else if(menu_group == 'activity_tools'){
                    return false
                }else if(menu_group == 'rsp_tools'){
                    return false
                }else if(menu_group == 'guest_tools'){
                    return true
                }else if(menu_group == 'user_sub'){
                    return false
                }else if(menu_group == 'guest_sub'){
                    return true
                }
            }
                

            
           
            
        },
        change_plant(){
            console.log(this.selected_plant_id)
        },
        switch_theme(){
            console.log('switch theme')
            jQuery(this).find('.vue-router-container').addClass('dark-theme')
        },
        
        multiplant_selection(){
            var vthis = this;
            if(vthis.request_package.user.plantIDs != null){
                
                if(JSON.parse(vthis.request_package.user.plantIDs).length > 0){

                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        }
        
    },
    computed: {

        version_number(){
            return moment('2020-11-10').format('YYYY:MM:DD')
        },
        plant_info(){
            return this.$store.getters.plant_info
        },
        easter_egg(){
            var locale = navigator.locale
            var date = moment().format('YYYY-MM-DD')
            if(moment(date).format('MM-DD') === '12'){
                return '❄️'
            }else if(moment(date).format('MM-DD') === '10-31'){
                return '🎃'

            }else if(moment(date).format('MM-DD') === '04-24'){
                return '🌍'

            }else if(moment(date).format('MM-DD') === '02-14'){
                return '💘'
            }else if(moment(date).format('MM-DD') === '01-01'){
                return '🎉'
            }else if(moment(date).format('MM-DD') === '07-04' && locale === 'en-US'){
                return '🇺🇸'
            }else if(moment(date).format('MM-DD') === '01-26' && locale === 'en-AU'){
                return '🇦🇺'
			}else{
                return '🥝'
            }
        }
        

    },
    
    updated: function(){
        
    },
    created: function(){
        
        
        
        
    },
    mounted: function(){
        jQuery('#theme-lever').click(function() {
            console.log('test')
            jQuery('#app').addClass('dark-theme')
            
        });

        jQuery('.collapsible-header').click(function(){

            

            if(jQuery(this).find('.sidenav-icon-right').hasClass('fa-rotate-90')){
                jQuery(this).find('.sidenav-icon-right').removeClass('fa-rotate-90')
                
            }else{
                jQuery(this).find('.sidenav-icon-right').addClass('fa-rotate-90')
                
            }

            
        })
        
        


        this.$nextTick(function(){
            

            M.AutoInit();
        });
    },
    watch: {
        selected_plant_id: function(val){
            var user_session = JSON.parse(session.getItem('user'));

            user_session.selected_plant_id = this.selected_plant_id
            session.removeItem('user')
            session.setItem('user', JSON.stringify(user_session))
            console.log(session.getItem('user'))
                    
            this.$store.dispatch('set_user_session')

            window.location.reload()


        }
        
    }
}
 

 </script>

 


// WEBPACK FOOTER //
// src/components/sidenav.vue